import { WSService } from "../../../utils/WSService";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";

const service = new WSService("/v2/onboarding/verifications");

export const getVerifications = async (): Promise<
  onboardingApiSpec.operations["getVerifications"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.get("");
  return data;
};

export const performVerification = async (
  verificationLevel: onboardingApiSpec.operations["performVerification"]["parameters"]["path"]["verificationLevel"]
): Promise<
  onboardingApiSpec.operations["performVerification"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.post("/" + verificationLevel);
  return data;
};
